export default "__VITE_ASSET__ClAzIoab__"